import axios from 'axios';
import { getToken } from '@/utils/auth';
import router from '@/router';
import env from '@/utils/env';
import { Message } from 'element-ui';

// 创建 Axios 实例
const service = axios.create({
  baseURL: env.baseURL, // 设置 API 的基础 URL
  // timeout: 5000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['token'] = getToken();
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    if (response && response.data) {
      const res = response.data;
      if (res.code == -10000) {
        localStorage.removeItem('token');
        localStorage.clear();
        Message({
          message: '登录失效，请重新登录！',
          type: 'warning',
          duration: 5 * 1000
        });
        router.push('/login')
        return res;
      } else if (res.code === 1) {
        Message({
          message: res.msg || '请输入必传参数',
          type: 'error'
        });
        return 'error'
      } else {
        return res;
      }
    } else {
      return 'error'
    }
  },
  error => {
    // 对响应错误做些什么
    return Promise.reject(error);
  }
);

export default service;